<template>
	<BaseButton
		:classes="computedClass"
		:label="label"
		:size="size"
		:disabled="isDisabled"
		@click="$emit('click')"
	/>
</template>
<script>
import BaseButton from '@/components/shared/Button/BaseButton/BaseButton.vue';

export default {
	name: 'ButtonSecondary',
	components: {
		BaseButton,
	},
	props: {
		label: {
			type: String,
			required: true,
		},
		isDisabled: {
			type: Boolean,
			default: false,
		},
		size: {
			type: String,
			default: 'md',
		},
	},
	computed: {
		computedClass() {
			return ['button__secondary'];
		},
	},
};
</script>
<style lang="scss" scoped>
@import './ButtonSecondary.scss';
</style>
